/* eslint-disable max-len */
import React from 'react';

interface PromoCodesIconProps {
    isActive?: boolean;
}

const PromoCodesIcon: React.FC<PromoCodesIconProps> = ({ isActive = false }) => {
    const innerFill = isActive ? 'white' : 'currentColor';

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.94443 1.72085L14.2792 7.05558C14.7674 7.54382 14.7674 8.33547 14.2792 8.82371L8.82371 14.2792C8.33547 14.7674 7.54382 14.7674 7.05558 14.2792L1.72085 8.94443C1.48633 8.70991 1.35462 8.39168 1.35462 8.05984V2.35462C1.35462 1.79581 1.80581 1.34462 2.36462 1.34462H8.05984C8.39168 1.34462 8.70991 1.47633 8.94443 1.72085Z"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
                strokeLinejoin="round"
            />
            <path
                d="M5 4.66634C5.36819 4.66634 5.66667 4.36786 5.66667 3.99967C5.66667 3.63148 5.36819 3.33301 5 3.33301C4.63181 3.33301 4.33333 3.63148 4.33333 3.99967C4.33333 4.36786 4.63181 4.66634 5 4.66634Z"
                fill={innerFill}
            />
        </svg>
    );
};

export default PromoCodesIcon;
